<template>
    <div class="box mb-3">
        <nav>
            <ul class="tabs" id="nav-tab" role="tablist">
                <li class="active" id="nav-products-tab" data-bs-toggle="tab" data-bs-target="#nav-products">Produtos</li>
                <li id="nav-comission-tab" data-bs-toggle="tab" data-bs-target="#nav-comission">Taxas e comissões</li>
                <li id="nav-comission-tab" data-bs-toggle="tab" data-bs-target="#nav-debts" v-if="props.comissions.debts_paid_by_order.length">Débitos</li>
            </ul>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane show active" id="nav-products" role="tabpanel">
                <div class="row">
                    <div class="col-md">
                        <TableProducts :products="props.products" :table_values="props.tables_values" />
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="nav-comission" role="tabpanel">
                <TableComissions :comissions="props.comissions" />
            </div>
            <div class="tab-pane" id="nav-debts" role="tabpanel" v-if="props.comissions.debts_paid_by_order.length">
                <TableDebts :comissions="props.comissions" />
            </div>
        </div>
    </div>
</template>

<script setup>
import TableProducts from '@/components/includes/orders/TableProduct';
import TableComissions from '@/components/includes/orders/TableComission';
import TableDebts from '@/components/includes/orders/TableDebts.vue';
const props = defineProps({
    products: {
        required: true,
        default: null
    },

    tables_values: {
        required: true,
        default: null
    },

    comissions: {
        required: true,
        default: null
    }
});
</script>

<style scoped>
.tabs {
    display: flex;
    width: 100%;
    text-align: center;
    padding: 0;
    margin: 0;
}

.tabs li {
    display: inline-block;
    padding: 20px 20px;
    font-weight: 600;
    cursor: pointer;
    color: #767676;
    border-bottom: 1px #ddd solid;
    width: 100%;
}

.tabs li.active {
    border-bottom: 2px #28bc6d solid;
}

div p a {
    text-decoration: underline !important;;
}
</style>